import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'thumbnail',
    standalone: false
})

export class ThumbnailPipe implements PipeTransform {
    transform(media): string {
        if (!media || !media.length) {
            return '/assets/img/app/no-image.png';
        }
        const thumbMedia = media.find(response => response.type === 'THUMB_MEDIA') ||
                           media.find(response => response.type === 'IMAGE_MEDIA');
        return thumbMedia?.url || '/assets/img/app/no-image.png';
    }
}
